import React from "react";
import { Box } from "@mui/system";
import Loader from "components/loader";
import ServicesTable from "components/tables/servicesTable/Index";
import { useSelector } from "react-redux";
import { ReducersModal } from "utils/modals";

const ServiceManagement = () => {
  const { loader, result } = useSelector(
    (state: ReducersModal) => state.ServiceTypeReducer
  );

  return (
    <Box>
      <ServicesTable />
      {loader && (result.length > 0 || result.length === 0) && <Loader />}
    </Box>
  );
};

export default ServiceManagement;
